<template>
    <div>
        <h2>This is Catering Footer Section</h2>
    </div>
</template>
  
<script>
  export default {
    name: 'CateringFooter'
  }
</script>
  
<style scoped>
 
</style>